// SVG-иконки для TopBar (Fusion 360 style).
// Все иконки квадратные, размер задаётся через CSS (currentColor для заливки).
//
// Используем `stroke="currentColor"` чтобы цвет иконки совпадал с цветом текста
// в кнопке (на hover/active меняется естественно).

import React from 'react';

const baseProps = {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    strokeWidth: 1.6,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
};

// Если передан `color` — задаём его как stroke у svg, иначе наследуем
// currentColor от родителя (как было). Все child-paths используют
// stroke="currentColor", потому что для них родитель — svg.
const Icon = ({ size = 28, viewBox = '0 0 32 32', color, children }) => (
    <svg
        width={size}
        height={size}
        viewBox={viewBox}
        stroke={color || 'currentColor'}
        {...baseProps}
    >
        {children}
    </svg>
);


// === SKETCH ===
export const IconSketch = (props) => (
    <Icon {...props}>
        {/* Лист эскиза с карандашом */}
        <rect x="5" y="6" width="18" height="20" rx="1.5"/>
        <path d="M14 14 L26 26"/>
        <path d="M22 22 L25 25 L27 27 L25 25 Z" fill="currentColor" fillOpacity="0.25"/>
        <path d="M9 11 L17 11"/>
        <path d="M9 15 L13 15"/>
    </Icon>
);


// === CREATE → EXTRUDE ===
export const IconExtrude = (props) => (
    <Icon {...props}>
        {/* Прямоугольник снизу + куб над ним со стрелкой вверх */}
        <rect x="6" y="20" width="14" height="6" stroke="currentColor" opacity="0.55" strokeDasharray="2 2"/>
        <path d="M6 20 L9 14 L23 14 L20 20"/>
        <path d="M9 14 L9 8"/>
        <path d="M23 14 L23 8"/>
        <path d="M9 8 L23 8"/>
        <path d="M16 6 L16 2 M13 5 L16 2 L19 5"/>
    </Icon>
);


// === CREATE → REVOLVE ===
export const IconRevolve = (props) => (
    <Icon {...props}>
        {/* Силуэт + ось */}
        <path d="M16 4 L16 28" strokeDasharray="2 2"/>
        <path d="M10 6 Q14 10 14 16 Q14 22 10 26"/>
        <ellipse cx="13" cy="16" rx="6" ry="2.5" opacity="0.55"/>
    </Icon>
);


// === CREATE → SWEEP ===
export const IconSweep = (props) => (
    <Icon {...props}>
        <path d="M5 24 Q10 8 22 8 Q27 8 27 14"/>
        <circle cx="6" cy="24" r="2.2"/>
        <ellipse cx="22" cy="8" rx="3" ry="1.5" opacity="0.55"/>
    </Icon>
);


// === CREATE → LOFT ===
export const IconLoft = (props) => (
    <Icon {...props}>
        <ellipse cx="9" cy="10" rx="4" ry="2" opacity="0.7"/>
        <ellipse cx="22" cy="22" rx="6" ry="3" opacity="0.7"/>
        <path d="M5 10 L16 22"/>
        <path d="M13 10 L28 22"/>
    </Icon>
);


// === CREATE → BOX ===
export const IconBox = (props) => (
    <Icon {...props}>
        <path d="M6 11 L16 6 L26 11 L26 23 L16 28 L6 23 Z"/>
        <path d="M6 11 L16 16 L26 11"/>
        <path d="M16 16 L16 28"/>
    </Icon>
);


// === CREATE → CYLINDER ===
export const IconCylinder = (props) => (
    <Icon {...props}>
        <ellipse cx="16" cy="7" rx="9" ry="3"/>
        <path d="M7 7 L7 25"/>
        <path d="M25 7 L25 25"/>
        <path d="M7 25 Q7 28 16 28 Q25 28 25 25"/>
    </Icon>
);


// === CREATE → SPHERE ===
export const IconSphere = (props) => (
    <Icon {...props}>
        <circle cx="16" cy="16" r="11"/>
        <ellipse cx="16" cy="16" rx="11" ry="4" opacity="0.55"/>
        <path d="M5 16 L27 16" opacity="0.55"/>
    </Icon>
);


// === CREATE → TORUS ===
export const IconTorus = (props) => (
    <Icon {...props}>
        <ellipse cx="16" cy="16" rx="11" ry="6"/>
        <ellipse cx="16" cy="16" rx="5" ry="2.5" opacity="0.55"/>
    </Icon>
);


// === CREATE → COIL ===
export const IconCoil = (props) => (
    <Icon {...props}>
        <ellipse cx="16" cy="8" rx="9" ry="2.5"/>
        <ellipse cx="16" cy="16" rx="9" ry="2.5"/>
        <ellipse cx="16" cy="24" rx="9" ry="2.5"/>
        <path d="M7 8 Q7 12 16 12 Q25 12 25 8"/>
        <path d="M7 16 Q7 20 16 20 Q25 20 25 16"/>
    </Icon>
);


// === CREATE → PIPE ===
export const IconPipe = (props) => (
    <Icon {...props}>
        <path d="M5 22 Q5 8 16 8 Q27 8 27 22"/>
        <ellipse cx="5" cy="22" rx="2.5" ry="2"/>
        <ellipse cx="27" cy="22" rx="2.5" ry="2"/>
    </Icon>
);


// === CREATE → THREAD ===
export const IconThread = (props) => (
    <Icon {...props}>
        <rect x="11" y="5" width="10" height="22" rx="0.5"/>
        <path d="M11 9 L21 9 M11 13 L21 13 M11 17 L21 17 M11 21 L21 21 M11 25 L21 25" opacity="0.7"/>
    </Icon>
);


// === CREATE → RIB ===
export const IconRib = (props) => (
    <Icon {...props}>
        <path d="M6 26 L26 26 L26 18 L20 12 L20 6"/>
        <path d="M14 26 L14 16" opacity="0.6"/>
    </Icon>
);


// === CREATE → WEB ===
export const IconWeb = (props) => (
    <Icon {...props}>
        <path d="M5 26 L27 26"/>
        <path d="M9 26 L9 14 L23 14 L23 26"/>
        <path d="M16 14 L16 6"/>
    </Icon>
);


// === CREATE → HOLE ===
export const IconHole = (props) => (
    <Icon {...props}>
        <rect x="5" y="6" width="22" height="20" rx="1.5"/>
        <circle cx="16" cy="16" r="4" fill="currentColor" fillOpacity="0.25"/>
        <circle cx="16" cy="16" r="2"/>
    </Icon>
);


// === CREATE → PATTERN ===
export const IconPattern = (props) => (
    <Icon {...props}>
        <rect x="5" y="5" width="6" height="6"/>
        <rect x="13" y="5" width="6" height="6" opacity="0.6"/>
        <rect x="21" y="5" width="6" height="6" opacity="0.4"/>
        <rect x="5" y="13" width="6" height="6" opacity="0.6"/>
        <rect x="13" y="13" width="6" height="6" opacity="0.4"/>
        <rect x="5" y="21" width="6" height="6" opacity="0.4"/>
    </Icon>
);


// === CREATE → CIRCULAR PATTERN ===
// Квадратики по окружности вокруг центральной оси.
export const IconCircPattern = (props) => (
    <Icon {...props}>
        <circle cx="16" cy="16" r="9" strokeDasharray="2 2" fill="none"/>
        <rect x="13" y="3" width="6" height="6"/>
        <rect x="23" y="13" width="6" height="6" opacity="0.7"/>
        <rect x="13" y="23" width="6" height="6" opacity="0.7"/>
        <rect x="3" y="13" width="6" height="6" opacity="0.7"/>
    </Icon>
);


// === CREATE → MIRROR ===
export const IconMirror = (props) => (
    <Icon {...props}>
        <path d="M16 4 L16 28" strokeDasharray="2 2"/>
        <path d="M5 24 L13 8 L13 24 Z"/>
        <path d="M27 24 L19 8 L19 24 Z" opacity="0.6"/>
    </Icon>
);


// === MODIFY → FILLET ===
export const IconFillet = (props) => (
    <Icon {...props}>
        <path d="M6 26 L6 14 Q6 6 14 6 L26 6"/>
        <path d="M6 26 L26 26 L26 6" opacity="0.45" strokeDasharray="2 2"/>
    </Icon>
);


// === MODIFY → CHAMFER ===
export const IconChamfer = (props) => (
    <Icon {...props}>
        <path d="M6 26 L6 14 L14 6 L26 6"/>
        <path d="M6 26 L26 26 L26 6" opacity="0.45" strokeDasharray="2 2"/>
    </Icon>
);


// === MODIFY → SHELL ===
export const IconShell = (props) => (
    <Icon {...props}>
        <path d="M6 11 L16 6 L26 11 L26 23 L16 28 L6 23 Z"/>
        <path d="M10 13 L16 10 L22 13 L22 21 L16 24 L10 21 Z" opacity="0.55"/>
    </Icon>
);


// === MODIFY → DRAFT ===
export const IconDraft = (props) => (
    <Icon {...props}>
        <path d="M9 6 L23 6 L26 26 L6 26 Z"/>
    </Icon>
);


// === MODIFY → SCALE ===
export const IconScale = (props) => (
    <Icon {...props}>
        <rect x="6" y="14" width="12" height="12"/>
        <rect x="14" y="6" width="12" height="12" opacity="0.5"/>
        <path d="M18 14 L26 6" strokeDasharray="2 2"/>
    </Icon>
);


// === MODIFY → COMBINE (boolean) ===
export const IconCombine = (props) => (
    <Icon {...props}>
        <circle cx="13" cy="16" r="8"/>
        <circle cx="20" cy="16" r="8" opacity="0.65"/>
    </Icon>
);


// === MODIFY → MOVE/COPY ===
export const IconMove = (props) => (
    <Icon {...props}>
        <path d="M16 4 L16 28 M4 16 L28 16"/>
        <path d="M13 7 L16 4 L19 7"/>
        <path d="M13 25 L16 28 L19 25"/>
        <path d="M7 13 L4 16 L7 19"/>
        <path d="M25 13 L28 16 L25 19"/>
    </Icon>
);


// === MODIFY → DELETE ===
export const IconDelete = (props) => (
    <Icon {...props}>
        <path d="M8 9 L24 9 L22 27 L10 27 Z"/>
        <path d="M6 9 L26 9"/>
        <path d="M12 9 L12 5 L20 5 L20 9"/>
        <path d="M14 14 L14 22 M18 14 L18 22" opacity="0.6"/>
    </Icon>
);


// === ASSEMBLE → JOINT ===
export const IconJoint = (props) => (
    <Icon {...props}>
        <circle cx="11" cy="16" r="6"/>
        <circle cx="21" cy="16" r="6" opacity="0.55"/>
        <circle cx="16" cy="16" r="2" fill="currentColor"/>
    </Icon>
);


// === ASSEMBLE → COMPONENT ===
export const IconComponent = (props) => (
    <Icon {...props}>
        <rect x="5" y="5" width="10" height="10"/>
        <rect x="17" y="5" width="10" height="10" opacity="0.6"/>
        <rect x="5" y="17" width="10" height="10" opacity="0.6"/>
        <rect x="17" y="17" width="10" height="10" opacity="0.4"/>
    </Icon>
);


// === CONSTRUCT → PLANE ===
export const IconPlane = (props) => (
    <Icon {...props}>
        <path d="M4 12 L20 6 L28 12 L12 18 Z"/>
        <path d="M16 18 L16 26" opacity="0.55"/>
    </Icon>
);


// === CONSTRUCT → AXIS ===
export const IconAxis = (props) => (
    <Icon {...props}>
        <path d="M6 26 L26 6"/>
        <path d="M22 6 L26 6 L26 10"/>
    </Icon>
);


// === CONSTRUCT → POINT ===
export const IconPoint = (props) => (
    <Icon {...props}>
        <circle cx="16" cy="16" r="3" fill="currentColor"/>
        <circle cx="16" cy="16" r="9" opacity="0.4"/>
    </Icon>
);


// === INSPECT ===
export const IconInspect = (props) => (
    <Icon {...props}>
        <circle cx="14" cy="14" r="8"/>
        <path d="M20 20 L27 27"/>
        <path d="M14 11 L14 17 M11 14 L17 14"/>
    </Icon>
);


// === INSPECT → MEASURE ===
export const IconMeasure = (props) => (
    <Icon {...props}>
        <rect x="3" y="11" width="26" height="10" rx="0.5" transform="rotate(-15, 16, 16)"/>
        <path d="M8 11 L8 15 M12 11 L12 15 M16 11 L16 16 M20 11 L20 15 M24 11 L24 15" transform="rotate(-15, 16, 16)" opacity="0.7"/>
    </Icon>
);


// === INSERT ===
export const IconInsert = (props) => (
    <Icon {...props}>
        <path d="M16 4 L16 22"/>
        <path d="M11 17 L16 22 L21 17"/>
        <rect x="5" y="24" width="22" height="4"/>
    </Icon>
);


// === SELECT ===
export const IconSelect = (props) => (
    <Icon {...props}>
        <path d="M6 5 L6 23 L11 19 L14 26 L17 24 L14 17 L21 17 Z" fill="currentColor" fillOpacity="0.15"/>
    </Icon>
);


// === MAKE / EXPORT ===
export const IconMake = (props) => (
    <Icon {...props}>
        <path d="M16 4 L16 22"/>
        <path d="M10 16 L16 22 L22 16"/>
        <rect x="5" y="24" width="22" height="4"/>
    </Icon>
);


// === FILE / FOLDER ===
export const IconFile = (props) => (
    <Icon {...props}>
        <path d="M5 8 L13 8 L15 11 L27 11 L27 25 L5 25 Z"/>
    </Icon>
);


// === Маленькая стрелка вниз для dropdown ===
export const IconChevronDown = ({ size = 8 }) => (
    <svg width={size} height={size} viewBox="0 0 8 8" fill="none">
        <path d="M1 2 L4 5 L7 2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);


// =====================================================================
// === Иконки для Browser (Fusion-style) ===============================
// =====================================================================

// Маленькая стрелка-«треугольник» свёрнутого узла дерева ▸ (есть expanded и collapsed)
export const IconTriRight = ({ size = 10 }) => (
    <svg width={size} height={size} viewBox="0 0 10 10" fill="currentColor">
        <path d="M3 1.5 L7 5 L3 8.5 Z"/>
    </svg>
);
export const IconTriDown = ({ size = 10 }) => (
    <svg width={size} height={size} viewBox="0 0 10 10" fill="currentColor">
        <path d="M1.5 3 L8.5 3 L5 7 Z"/>
    </svg>
);

// Глаз (видимый)
export const IconEye = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor"
         strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 8 Q5 3 8 3 Q11 3 15 8 Q11 13 8 13 Q5 13 1 8 Z"/>
        <circle cx="8" cy="8" r="2.2"/>
    </svg>
);

// Глаз перечёркнут (скрытый)
export const IconEyeHidden = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor"
         strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 8 Q5 3 8 3 Q11 3 15 8 Q11 13 8 13 Q5 13 1 8 Z" opacity="0.5"/>
        <circle cx="8" cy="8" r="2.2" opacity="0.5"/>
        <path d="M2 14 L14 2" strokeWidth="1.5"/>
    </svg>
);

// Папка (для категорий — Origin / Bodies / Sketches и т.п.)
export const IconFolder = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor" opacity="0.85">
        <path d="M1.5 4 L6 4 L7.5 5.5 L14.5 5.5 L14.5 13 L1.5 13 Z"/>
    </svg>
);

// Документ (главный узел)
export const IconDocument = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor"
         strokeWidth="1.3" strokeLinejoin="round">
        <path d="M3 1 L10 1 L13 4 L13 15 L3 15 Z"/>
        <path d="M10 1 L10 4 L13 4"/>
    </svg>
);

// Маркер активного документа — кружок справа (как в Fusion ◉)
export const IconActiveDot = ({ size = 12 }) => (
    <svg width={size} height={size} viewBox="0 0 12 12" fill="none">
        <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="1.2"/>
        <circle cx="6" cy="6" r="2.2" fill="currentColor"/>
    </svg>
);

// Шестерёнка (Document Settings)
export const IconGear = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor"
         strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="8" cy="8" r="2.2"/>
        <path d="M8 1 L8 3 M8 13 L8 15 M1 8 L3 8 M13 8 L15 8 M3 3 L4.5 4.5 M11.5 11.5 L13 13 M3 13 L4.5 11.5 M11.5 4.5 L13 3"/>
    </svg>
);

// Иконка тела (Body) — изометрический куб
export const IconBodyItem = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor"
         strokeWidth="1.2" strokeLinejoin="round">
        <path d="M3 5 L8 2.5 L13 5 L13 11 L8 13.5 L3 11 Z"/>
        <path d="M3 5 L8 7.5 L13 5"/>
        <path d="M8 7.5 L8 13.5"/>
    </svg>
);

// Иконка эскиза (Sketch)
export const IconSketchItem = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor"
         strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="9" height="11"/>
        <path d="M7 7 L13 13"/>
        <path d="M11 11 L13.5 13.5 L13 14 Z" fill="currentColor"/>
    </svg>
);

// Иконка плоскости (XY/XZ/YZ под Origin)
export const IconPlaneItem = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor"
         strokeWidth="1.2" strokeLinejoin="round">
        <path d="M2 6 L10 3 L14 6 L6 9 Z"/>
    </svg>
);

// Иконка оси координат (X / Y / Z под Origin)
export const IconAxisItem = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor"
         strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 13 L13 2"/>
        <path d="M11 2 L13 2 L13 4"/>
    </svg>
);

// Точка (Origin point)
export const IconOriginPoint = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="2.5" fill="currentColor"/>
        <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
    </svg>
);

// «Глобус» (Origin)
export const IconOrigin = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor"
         strokeWidth="1.2">
        <circle cx="8" cy="8" r="6"/>
        <ellipse cx="8" cy="8" rx="6" ry="2.5"/>
        <path d="M8 2 L8 14"/>
    </svg>
);


// === Иконки для расширенной группы СОЗДАТЬ (Fusion 360 1:1) ===
// Все в стиле остальных: viewBox 24×24, line-art с currentColor stroke.

// Form (T-spline / лепка) — два кружочка-узла со связью
export const IconForm = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 17 C 4 10, 12 6, 12 6 S 20 10, 20 17"/>
        <path d="M4 17 L20 17"/>
        <circle cx="6" cy="17" r="1.5"/>
        <circle cx="18" cy="17" r="1.5"/>
        <circle cx="12" cy="6" r="1.5"/>
    </svg>
);

// Derive (производное) — стрелка из одного контейнера в другой
export const IconDerive = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="6" width="7" height="12" rx="1"/>
        <rect x="14" y="6" width="7" height="12" rx="1"/>
        <path d="M10 12 L14 12"/>
        <path d="M12.5 10 L14.5 12 L12.5 14"/>
    </svg>
);

// Thicken (утолщение поверхности)
export const IconThicken = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 14 C 8 10, 16 10, 21 14"/>
        <path d="M3 18 C 8 14, 16 14, 21 18"/>
        <path d="M3 14 L3 18"/>
        <path d="M21 14 L21 18"/>
    </svg>
);

// Boundary Fill — куб с заштрихованной внутренней областью
export const IconBoundaryFill = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="4" width="16" height="16" rx="1"/>
        <path d="M8 8 L16 16" strokeWidth="1.2"/>
        <path d="M11 8 L16 13" strokeWidth="1.2"/>
        <path d="M8 11 L13 16" strokeWidth="1.2"/>
        <path d="M14 8 L16 10" strokeWidth="1.2"/>
        <path d="M8 14 L10 16" strokeWidth="1.2"/>
    </svg>
);

// Create Mesh — сетка треугольников
export const IconMesh = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 6 L20 6 L12 18 Z"/>
        <path d="M4 6 L12 12"/>
        <path d="M20 6 L12 12"/>
        <path d="M12 18 L12 12"/>
    </svg>
);

// Mesh Section Sketch — плоскость сечения mesh-объекта
export const IconMeshSectionSketch = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 8 L14 5 L20 9 L10 12 Z"/>
        <path d="M6 14 L18 14"/>
        <path d="M6 17 L18 17"/>
        <path d="M6 14 L6 17"/>
        <path d="M18 14 L18 17"/>
    </svg>
);

// Base Feature — параллелепипед с точкой-якорем
export const IconBaseFeature = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 9 L12 6 L19 9 L19 17 L12 20 L5 17 Z"/>
        <path d="M5 9 L12 12 L19 9"/>
        <path d="M12 12 L12 20"/>
        <circle cx="12" cy="6" r="1.2" fill="currentColor"/>
    </svg>
);

// 3D PCB — плата с дорожками
export const IconPcb = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="6" width="18" height="12" rx="1"/>
        <circle cx="8" cy="10" r="1"/>
        <circle cx="16" cy="14" r="1"/>
        <path d="M8 11 L8 14 L12 14"/>
        <path d="M16 13 L16 10 L12 10"/>
    </svg>
);


// === Иконки для расширенной группы ИЗМЕНИТЬ ===

// Press Pull — стрелка вверх + поверхность (главный инструмент Modify)
export const IconPressPull = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 17 L21 17"/>
        <path d="M3 20 L21 20"/>
        <path d="M12 14 L12 4"/>
        <path d="M9 7 L12 4 L15 7"/>
    </svg>
);

// Offset Face — грань со стрелкой смещения наружу
export const IconOffsetFace = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="6" y="6" width="8" height="12"/>
        <path d="M16 8 L18 8 M16 12 L18 12 M16 16 L18 16" strokeDasharray="2 2"/>
        <path d="M14 12 L20 12"/>
        <path d="M18 10 L20 12 L18 14"/>
    </svg>
);

// Replace Face — две грани со стрелкой замены между ними
export const IconReplaceFace = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="5" width="7" height="14"/>
        <rect x="14" y="5" width="7" height="14" strokeDasharray="2 2"/>
        <path d="M10 12 L14 12"/>
        <path d="M12 10 L14 12 L12 14"/>
    </svg>
);

// Split Face — грань с разделительной линией
export const IconSplitFace = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="4" width="16" height="16"/>
        <path d="M4 12 L20 12" strokeDasharray="3 2"/>
    </svg>
);

// Silhouette Split — куб с разделением по силуэту
export const IconSilhouetteSplit = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 9 L12 6 L19 9 L19 17 L12 20 L5 17 Z"/>
        <path d="M5 9 L12 12 L19 9"/>
        <path d="M12 12 L12 20"/>
        <path d="M8 7.5 L8 18.5" strokeDasharray="2 2"/>
        <path d="M16 7.5 L16 18.5" strokeDasharray="2 2"/>
    </svg>
);

// Align — выравнивание двух объектов
export const IconAlign = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="6" width="6" height="12"/>
        <rect x="14" y="9" width="6" height="9"/>
        <path d="M2 18 L22 18"/>
    </svg>
);

// Physical Material — атом / молекула
export const IconMaterial = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="2"/>
        <ellipse cx="12" cy="12" rx="9" ry="3.5"/>
        <ellipse cx="12" cy="12" rx="9" ry="3.5" transform="rotate(60 12 12)"/>
        <ellipse cx="12" cy="12" rx="9" ry="3.5" transform="rotate(-60 12 12)"/>
    </svg>
);

// Appearance — палитра / кружок-цвет
export const IconAppearance = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 4 C 7 4, 3 8, 3 12 C 3 15, 5 17, 8 17 C 9 17, 9 16, 9 15 C 9 13, 11 13, 11 15 C 11 17, 12 19, 14 19 C 18 19, 21 16, 21 12 C 21 8, 17 4, 12 4 Z"/>
        <circle cx="7" cy="10" r="1" fill="currentColor"/>
        <circle cx="11" cy="7" r="1" fill="currentColor"/>
        <circle cx="16" cy="8" r="1" fill="currentColor"/>
        <circle cx="17" cy="13" r="1" fill="currentColor"/>
    </svg>
);

// Manage Materials — список/папка с кубом
export const IconManageMaterials = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="6" width="18" height="14" rx="1"/>
        <path d="M3 10 L21 10"/>
        <circle cx="7" cy="14" r="1.2"/>
        <path d="M11 14 L18 14"/>
        <circle cx="7" cy="17" r="1.2"/>
        <path d="M11 17 L18 17"/>
    </svg>
);

// Change Parameters — таблица параметров с буквой fx
export const IconParameters = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="16" rx="1"/>
        <path d="M3 9 L21 9"/>
        <path d="M9 4 L9 20"/>
        <path d="M6 14 L8 14 M7 12 L7 17" strokeWidth="1.2"/>
        <path d="M13 14 L18 14" strokeWidth="1.2"/>
        <path d="M13 17 L18 17" strokeWidth="1.2"/>
    </svg>
);

// Compute All — шестерня с восклицательным знаком
export const IconComputeAll = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/>
        <path d="M12 3 L12 6 M12 18 L12 21 M3 12 L6 12 M18 12 L21 12"/>
        <path d="M5.6 5.6 L7.7 7.7 M16.3 16.3 L18.4 18.4 M5.6 18.4 L7.7 16.3 M16.3 7.7 L18.4 5.6"/>
    </svg>
);


// =====================================================================
// === ИКОНКИ РЕЖИМА ЭСКИЗА ============================================
// =====================================================================
// Все используют общий <Icon> wrapper (поддержка `color` prop).

// СОЗДАТЬ: line, rectangle, circle, arc, polygon, spline, point, text
export const IconSketchLine = (props) => (
    <Icon {...props}>
        <path d="M5 26 L26 6"/>
        <circle cx="5" cy="26" r="1.5" fill="currentColor"/>
        <circle cx="26" cy="6" r="1.5" fill="currentColor"/>
    </Icon>
);

export const IconSketchRect = (props) => (
    <Icon {...props}>
        <rect x="6" y="9" width="20" height="14"/>
        <circle cx="6" cy="9" r="1.3" fill="currentColor"/>
        <circle cx="26" cy="23" r="1.3" fill="currentColor"/>
    </Icon>
);

export const IconSketchCircle = (props) => (
    <Icon {...props}>
        <circle cx="16" cy="16" r="10"/>
        <circle cx="16" cy="16" r="1.3" fill="currentColor"/>
        <path d="M16 16 L24 12" strokeDasharray="2 2"/>
    </Icon>
);

export const IconSketchArc = (props) => (
    <Icon {...props}>
        <path d="M5 24 Q16 4 27 24"/>
        <circle cx="5" cy="24" r="1.3" fill="currentColor"/>
        <circle cx="27" cy="24" r="1.3" fill="currentColor"/>
        <circle cx="16" cy="9" r="1" fill="currentColor"/>
    </Icon>
);

export const IconSketchPolygon = (props) => (
    <Icon {...props}>
        <path d="M16 4 L26 11 L23 23 L9 23 L6 11 Z"/>
    </Icon>
);

export const IconSketchSpline = (props) => (
    <Icon {...props}>
        <path d="M5 24 Q10 4 16 16 Q22 28 27 8"/>
        <circle cx="5" cy="24" r="1.3" fill="currentColor"/>
        <circle cx="27" cy="8" r="1.3" fill="currentColor"/>
        <circle cx="16" cy="16" r="1.3" fill="currentColor"/>
    </Icon>
);

export const IconSketchPoint = (props) => (
    <Icon {...props}>
        <circle cx="16" cy="16" r="2.5" fill="currentColor"/>
        <path d="M16 6 L16 10 M16 22 L16 26 M6 16 L10 16 M22 16 L26 16" opacity="0.6"/>
    </Icon>
);

export const IconSketchText = (props) => (
    <Icon {...props}>
        <path d="M7 9 L7 7 L25 7 L25 9"/>
        <path d="M16 7 L16 25"/>
        <path d="M12 25 L20 25"/>
    </Icon>
);

export const IconSketchEllipse = (props) => (
    <Icon {...props}>
        <ellipse cx="16" cy="16" rx="11" ry="7"/>
        <circle cx="16" cy="16" r="1.3" fill="currentColor"/>
    </Icon>
);

export const IconSketchSlot = (props) => (
    <Icon {...props}>
        <path d="M10 10 L22 10 A 6 6 0 0 1 22 22 L10 22 A 6 6 0 0 1 10 10 Z"/>
    </Icon>
);

// ИЗМЕНИТЬ: fillet, trim, extend, offset, mirror, pattern, project, dimension
export const IconSketchFillet = (props) => (
    <Icon {...props}>
        <path d="M6 6 L6 16 A 10 10 0 0 1 16 26 L26 26"/>
        <path d="M6 6 L6 26 L26 26" strokeDasharray="2 2" opacity="0.5"/>
    </Icon>
);

export const IconSketchTrim = (props) => (
    <Icon {...props}>
        {/* Ножницы */}
        <circle cx="9" cy="9" r="3"/>
        <circle cx="9" cy="23" r="3"/>
        <path d="M11 11 L26 22"/>
        <path d="M11 21 L26 10"/>
    </Icon>
);

export const IconSketchExtend = (props) => (
    <Icon {...props}>
        <path d="M5 16 L16 16"/>
        <path d="M16 16 L26 16" strokeDasharray="2 2"/>
        <path d="M22 12 L26 16 L22 20"/>
    </Icon>
);

export const IconSketchOffset = (props) => (
    <Icon {...props}>
        <circle cx="16" cy="16" r="6"/>
        <circle cx="16" cy="16" r="11" strokeDasharray="2 2"/>
    </Icon>
);

export const IconSketchMirror = (props) => (
    <Icon {...props}>
        <path d="M16 4 L16 28" strokeDasharray="2 2"/>
        <path d="M6 10 L13 10 L13 22 L6 22 Z"/>
        <path d="M26 10 L19 10 L19 22 L26 22 Z" opacity="0.55"/>
    </Icon>
);

export const IconSketchPattern = (props) => (
    <Icon {...props}>
        <rect x="5" y="5" width="6" height="6"/>
        <rect x="13" y="5" width="6" height="6"/>
        <rect x="21" y="5" width="6" height="6"/>
        <rect x="5" y="13" width="6" height="6"/>
        <rect x="13" y="13" width="6" height="6"/>
        <rect x="21" y="13" width="6" height="6"/>
        <rect x="5" y="21" width="6" height="6"/>
        <rect x="13" y="21" width="6" height="6"/>
        <rect x="21" y="21" width="6" height="6"/>
    </Icon>
);

export const IconSketchProject = (props) => (
    <Icon {...props}>
        <path d="M5 22 L5 8 L18 8"/>
        <path d="M14 14 L27 14 L27 26 L14 26 Z"/>
        <path d="M14 8 L14 14"/>
    </Icon>
);

export const IconSketchDimension = (props) => (
    <Icon {...props}>
        <path d="M6 16 L26 16"/>
        <path d="M6 12 L6 20"/>
        <path d="M26 12 L26 20"/>
        <path d="M9 13 L6 16 L9 19"/>
        <path d="M23 13 L26 16 L23 19"/>
    </Icon>
);

export const IconConstructionLine = (props) => (
    <Icon {...props}>
        <path d="M5 26 L26 6" strokeDasharray="3 2"/>
    </Icon>
);

// ОГРАНИЧЕНИЯ
export const IconConstraintH = (props) => (
    <Icon {...props}>
        <path d="M5 16 L27 16"/>
        <path d="M5 8 L5 24"/>
        <path d="M27 8 L27 24"/>
    </Icon>
);

export const IconConstraintV = (props) => (
    <Icon {...props}>
        <path d="M16 5 L16 27"/>
        <path d="M8 5 L24 5"/>
        <path d="M8 27 L24 27"/>
    </Icon>
);

export const IconConstraintParallel = (props) => (
    <Icon {...props}>
        <path d="M9 5 L9 27"/>
        <path d="M22 5 L22 27"/>
    </Icon>
);

export const IconConstraintPerpendicular = (props) => (
    <Icon {...props}>
        <path d="M6 6 L6 26 L26 26"/>
        <path d="M6 22 L10 22 L10 26"/>
    </Icon>
);

export const IconConstraintCoincident = (props) => (
    <Icon {...props}>
        <circle cx="16" cy="16" r="6"/>
        <circle cx="16" cy="16" r="2" fill="currentColor"/>
    </Icon>
);

export const IconConstraintTangent = (props) => (
    <Icon {...props}>
        <circle cx="14" cy="18" r="9"/>
        <path d="M3 9 L29 9"/>
    </Icon>
);

export const IconConstraintEqual = (props) => (
    <Icon {...props}>
        <path d="M6 12 L26 12"/>
        <path d="M6 20 L26 20"/>
    </Icon>
);

export const IconConstraintMidpoint = (props) => (
    <Icon {...props}>
        <path d="M5 16 L27 16"/>
        <circle cx="16" cy="16" r="2.5" fill="currentColor"/>
        <circle cx="5" cy="16" r="1.3"/>
        <circle cx="27" cy="16" r="1.3"/>
    </Icon>
);

export const IconConstraintSymmetric = (props) => (
    <Icon {...props}>
        <path d="M16 4 L16 28" strokeDasharray="2 2"/>
        <circle cx="9" cy="16" r="2"/>
        <circle cx="23" cy="16" r="2"/>
    </Icon>
);

export const IconConstraintFix = (props) => (
    <Icon {...props}>
        {/* Замок */}
        <rect x="9" y="14" width="14" height="11" rx="1"/>
        <path d="M12 14 L12 10 A 4 4 0 0 1 20 10 L20 14"/>
        <circle cx="16" cy="19" r="1.3" fill="currentColor"/>
    </Icon>
);

export const IconConstraintConcentric = (props) => (
    <Icon {...props}>
        <circle cx="16" cy="16" r="10"/>
        <circle cx="16" cy="16" r="5"/>
        <circle cx="16" cy="16" r="1" fill="currentColor"/>
    </Icon>
);

// Завершить эскиз — зелёная галочка
export const IconFinishSketch = (props) => (
    <Icon {...props}>
        <circle cx="16" cy="16" r="11"/>
        <path d="M10 16 L14 20 L22 12" strokeWidth="2.2"/>
    </Icon>
);
